import { recoveryURL } from "./api";

type errorImageHandlerParams = {
  e: Event;
  errorIndex: number;
  maxCountOfTryingForSource?: number;
};

export function errorImageHandler(
  { e, errorIndex = 0, maxCountOfTryingForSource = 3 }: errorImageHandlerParams,
  callback?: (
    urlForLoad: string,
    countOfTrying: number,
    maxCountOfTryingForSource: number
  ) => void,
  onExceedOfTryingSource?: (
    urlForLoad: string,
    countOfTrying: number,
    maxCountOfTryingForSource: number
  ) => void
) {
  const srcUrl = (e.target as HTMLImageElement).src;

  // TODO: research this method to load img just in e.target
  // const elementNode = e.target["__vnode"].el;
  // elementNode.onload = () => {
  //   this.previewImg = e.target.src;
  // };
  // e.target.src = srcUrl;

  if (!srcUrl) {
    throw new Error(`Target source URL is ${srcUrl}. String expected`);
  }

  const frisbuyDomainPart = "frisbuy";
  const isFrisbuyDomain = srcUrl.includes(frisbuyDomainPart);

  // NOTE: Try to get original source. If can't - use recoveryPath's logic
  if (isFrisbuyDomain) {
    if (errorIndex < maxCountOfTryingForSource) {
      callback && callback(srcUrl, errorIndex, maxCountOfTryingForSource);

      return;
    } else {
      onExceedOfTryingSource &&
        onExceedOfTryingSource(srcUrl, errorIndex, maxCountOfTryingForSource);
      return;
    }
  }

  // TODO: rewrite recoveryURL's logic after research with backenders
  // if (!isFrisbuyDomain) {
  //   let recoveryPath = recoveryURL(
  //     this.settings.srcDomain,
  //     this.post,
  //     this.post.media.indexOf(this.media),
  //     "image",
  //     this.isRetina,
  //     true
  //   );

  //   if (imageHighRes && this.errorIndex === maxCountOfTryingForSource) {
  //     recoveryPath += `&url=${encodeURIComponent(imageHighRes)}`;
  //   }

  //   if (++this.errorIndex > maxCountOfTryingForSource + 2) {
  //     this.errorIndex = 0;

  //     return;
  //   }

  //   callback(recoveryPath, errorIndex);
  // }
}

export function errorVideoHandler(
  { e, errorIndex = 0, maxCountOfTryingForSource = 3 }: errorImageHandlerParams,
  callback?: (
    urlForLoad: string,
    countOfTrying: number,
    maxCountOfTryingForSource: number
  ) => void,
  onExceedOfTryingSource?: (
    urlForLoad: string,
    countOfTrying: number,
    maxCountOfTryingForSource: number
  ) => void
) {
  const srcUrl = (e.target as HTMLVideoElement).src;

  if (!srcUrl) {
    throw new Error(`Target source URL is ${srcUrl}. String expected`);
  }

  const frisbuyDomainPart = "frisbuy";
  const isFrisbuyDomain = srcUrl.includes(frisbuyDomainPart);

  // NOTE: Try to get original source. If can't - use recoveryPath's logic
  if (isFrisbuyDomain) {
    if (errorIndex < maxCountOfTryingForSource) {
      callback && callback(srcUrl, errorIndex, maxCountOfTryingForSource);

      return;
    } else {
      onExceedOfTryingSource &&
        onExceedOfTryingSource(srcUrl, errorIndex, maxCountOfTryingForSource);
      return;
    }
  }

  // if (!isFrisbuyDomain) {
  //   let recoveryPath = recoveryURL(this.settings.srcDomain, this.slide, 0, "video");

  //   if (this.storyMedia.videoUrl && this.errorIndex === countOfTryingForSource) {
  //     recoveryPath += `&url=${decodeURIComponent(this.storyMedia.videoUrl)}`;
  //   }

  //   if (++this.errorIndex > countOfTryingForSource + 2) {
  //     if (this.isSelectedSlide) {
  //       setTimeout(() => {
  //         this.$emit("nextSlide");
  //       }, 1000);
  //     }

  //     this.errorIndex = 0;

  //     return;
  //   }

  //   console.warn("errorVideoHandler:", e);

  //   /*
  //   TODO: check this func. Mb change to
  //   this.$refs.video.dataset.src = recoveryPath;
  //   this.load();
  // */
  //   this.$refs.video.src = recoveryPath;
  //   this.$refs.video.load();
  // }
}
